export const PHONE_REGEX = new RegExp(`^(\\+?[\\d\\s\\-.()#]|(ext))+$`);
export const EMAIL_REGEX =
  /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+(?:(?!con)[a-zA-Z]){2,}))$/;
export const SIGNUP_LOGIN_EMAIL_REGEX = /^\s*\S+@\S+\.\S+\s*$/;
